// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orgchart-container {
  height: calc(100vh - 80px) !important;
  margin: unset !important;
  border: 0px !important;
  width: 100% !important;
  overflow: hidden;
}

.orgchart.myChart .oc-node > div {
  box-sizing: border-box;
  background-color: white;
  color: black;
  text-wrap: nowrap;
  border-radius: 8px;
  text-align: start;
}

.inactive {
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/containers/HRM/OrgChart/style.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,wBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAgBA;EACE,sBAAA;EACA,uBAAA;EAEA,YAAA;EACA,iBAAA;EAEA,kBAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,YAAA;AAfF","sourcesContent":[".orgchart-container {\n  height: calc(100vh - 80px) !important;\n  margin: unset !important;\n  border: 0px !important;\n  width: 100% !important;\n  overflow: hidden;\n}\n\n.orgchart.myChart {\n  // background-image: none !important;\n  // background: radial-gradient(#04233d, rgb(0, 132, 255), #cccff3, ) !important;\n}\n\n.orgchart.myChart > ul > li > ul li::before {\n  // border-top-color: rgb(179, 179, 179);\n}\n\n.orgchart.myChart > ul > li > ul li .oc-node::before,\n.orgchart.myChart ul li .oc-node:not(:only-child)::after {\n  // background-color: rgb(179, 179, 179);\n}\n\n.orgchart.myChart .oc-node > div {\n  box-sizing: border-box;\n  background-color: white;\n  // border: 1px solid rgb(221, 221, 221);\n  color: black;\n  text-wrap: nowrap;\n  // padding: 8px;\n  border-radius: 8px;\n  text-align: start;\n}\n\n.inactive {\n  opacity: 0.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
